import { createCalendarsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const CalendarsService = createCalendarsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
